export default __webpack_public_path__ + "static/media/instalarComputador.5736e099.png";